<template>
    <div>
        <lable>VR脳機能定点</lable>
    </div>
</template>
<script>
export default {
    
}
</script>